import script from "./AdditionalDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalDetails.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalDetails.vue?vue&type=style&index=0&id=7c14ab47&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c14ab47"]])

export default __exports__